<ng-content select="[~right]"></ng-content>

<ng-container *ngIf="visible$ | async">
	<div
		#backdrop
		moveToRoot
		class="pt-safe-t pr-safe-r pb-safe-b pl-safe-l top-0 left-0 w-full h-full flex absolute items-center justify-center box-border backdrop-menu backdrop z-10"
		(click)="close()"
	>
		<div
			class="wrapper-menu p-2 rounded-2.5 shadow-z-menu flex flex-col box-border"
			[class.bg-280]="!lightBg"
			[class.bg-180]="lightBg"
			[style.min-height]="minHeight"
			(click)="$event.stopPropagation()"
		>
			<div class="pb-2 flex-none w-full flex items-center justify-start">
				<div #left class="flex-none flex" [style.minWidth.px]="right?.clientWidth || 0">
					<ng-content select="[~left]"></ng-content>
				</div>

				<div
					class="px-2 flex-auto text-h5 truncate w-full fc-800 font-bold flex relative items-center justify-center text-center box-border"
				>
					<ng-content select="[~title]"></ng-content>
				</div>

				<div
					#right
					class="flex-none flex items-center justify-end"
					[style.minWidth.px]="left?.clientWidth || 0"
				>
					<button buttonIcon class="fc-400 flex" (click)="close()">
						<i class="icon-cross-close"></i>
					</button>
				</div>
			</div>

			<div
				class="flex-auto flex flex-col items-start justify-start scrollbar-fade overflow-auto"
			>
				<ng-content></ng-content>
			</div>

			<ng-content select="[~footer]"></ng-content>
		</div>
	</div>
</ng-container>
